import { GetServerSideProps } from 'next'
import { serverSideTranslations } from '../src/utils/convergence'
import React from 'react'
import { getLayout } from '../src/layouts/MainLayout'
import { CheckoutPage } from '../src/model'
import { withPublic } from '../src/component'
import { SignUpPage as SignUp } from '../src/page'
import { getTheme } from '../src/utils/server/convergence'

const I18N_NAMESPACE = ['common', 'terminalError', 'signUp', 'login', 'password']

const SignUpPage: CheckoutPage = (props) => <SignUp {...props} />

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { theme } = await getTheme(context)
  return {
    props: {
      theme,
      ...(await serverSideTranslations(context.locale as string, I18N_NAMESPACE)),
    },
  }
}

const SignUpPagePublic: CheckoutPage = withPublic(SignUpPage)
SignUpPagePublic.getLayout = getLayout()

export default SignUpPagePublic
